var exports = {
  "t8": "MobileFriendRequestItem.module__requestItem___Rm40dl",
  "eF": "MobileFriendRequestItem.module__userInfo___Rm40dl",
  "nT": "MobileFriendRequestItem.module__userName___Rm40dl",
  "G2": "MobileFriendRequestItem.module__requestStatus___Rm40dl",
  "hP": "MobileFriendRequestItem.module__actionButton___Rm40dl" + " " + __webpack_require__(180357)["AS"] + " " + __webpack_require__(180357)["ik"],
  "RK": "MobileFriendRequestItem.module__iconSize___Rm40dl",
};

module.exports = exports;
